/*
 *
 * QuestionnairesDetail constants
 *
 */

export const SLICE_NAME = 'questionnairesDetail';
